<div class="snippet" data-title="dot-typing">
  <div class="stage">
    <div class="dot-typing"></div>
  </div>
</div>